import { render, staticRenderFns } from "./FbAddProfileDialog.vue?vue&type=template&id=37b41ebc&scoped=true"
import script from "./FbAddProfileDialog.vue?vue&type=script&lang=js"
export * from "./FbAddProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./FbAddProfileDialog.vue?vue&type=style&index=0&id=37b41ebc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b41ebc",
  null
  
)

export default component.exports